import React from 'react';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
import './scss/SkeletonPageList.scss';

const SkeletonPageList = () => {
  return (
    <div className="skeleton-page-list">
      {/* Recent Section Skeleton */}
      <div className="skeleton-section recent">
        <Skeleton width={120} height={16} className="section-title-skeleton" style={{ marginBottom: 16 }} />
        <div className="skeleton-recent-grid">
          {[1, 2, 3, 4].map((i) => (
             <Skeleton key={i} height={160} borderRadius={12} />
          ))}
        </div>
      </div>

      {/* All Pages Section Skeleton */}
      <div className="skeleton-section all-pages">
         <div className="section-header-skeleton">
            <Skeleton width={100} height={20} />
            <Skeleton width={60} height={20} borderRadius={10} style={{ marginLeft: 12 }} />
         </div>
         
         <div className="skeleton-pages-grid">
            {[1, 2, 3, 4, 5, 6, 7, 8].map((i) => (
              <Skeleton key={i} height={80} borderRadius={10} />
            ))}
         </div>
      </div>
    </div>
  );
};

export default SkeletonPageList;
